import React, { useState } from 'react';
import { FiMonitor } from 'react-icons/fi';

import { TabBar, tabBarVariants } from '@components/TabBar';
import { StatusBadge, statusBadgeTones } from '@components/StatusBadge';
import { Toggle } from '@components/Toggle';

import { SettingsPanelHeader } from './SettingsPanelHeader.component';
import { ScreenshotSettingsTab } from './ScreenshotSettingsTab.component';
import { PlaceholderSection } from './PlaceholderSection.component';
import {
  SCREENSHOT_TABS,
  screenshotTabKeys,
} from '../SettingsRedesign.constants';

import styles from './ScreenshotsMonitoringSection.module.scss';

export const ScreenshotsMonitoringSection = () => {
  const [enabled, setEnabled] = useState(true);
  const [activeTab, setActiveTab] = useState(
    screenshotTabKeys.screenshotSettings
  );

  const activeTabLabel = SCREENSHOT_TABS.find(
    (tab) => tab.value === activeTab
  )?.label;

  return (
    <>
      <SettingsPanelHeader
        icon={<FiMonitor size={20} color="var(--indigo-600)" />}
        title="Screenshots & Monitoring"
        description="Configure how screenshots are captured and how employee activity is monitored."
        rightSlot={
          <>
            <StatusBadge
              label={enabled ? 'Enabled' : 'Disabled'}
              tone={
                enabled ? statusBadgeTones.success : statusBadgeTones.default
              }
            />
            <Toggle checked={enabled} onChange={setEnabled} />
          </>
        }
      />

      <TabBar
        tabs={SCREENSHOT_TABS}
        activeTab={activeTab}
        onTabClick={setActiveTab}
        variant={tabBarVariants.pill}
      />

      <div className={styles.tabContent}>
        {activeTab === screenshotTabKeys.screenshotSettings ? (
          <ScreenshotSettingsTab />
        ) : (
          <PlaceholderSection title={activeTabLabel} />
        )}
      </div>
    </>
  );
};

ScreenshotsMonitoringSection.displayName = 'ScreenshotsMonitoringSection';
